import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	isAuthenticated: false,
	loading: false,
	data: null,
	error: null,
	statusMessage: null,
	openStreakModal: false
};

const setOpenStreakModal = (state, action) =>
	updateObject(state, {
		openStreakModal: action.openStreakModal
	});

const loginUserStart = (state) => updateObject(state, { loading: true, error: null });

const loginUserSuccess = (state, action) =>
	updateObject(state, {
		isAuthenticated: true,
		loading: false,
		data: action.data
	});

const loginUserFail = (state, action) =>
	updateObject(state, { error: action.error, loading: false });

const logoutUser = (state) => updateObject(state, initialState);

const registerUserFail = (state, action) =>
	updateObject(state, { error: action.error, loading: false });

const registerUserSuccess = (state) =>
	updateObject(state, {
		statusMessage:
      'Mai este doar un pas! Un e-mail de activare a fost trimis catre tine. Caută-l atât in inbox cât şi in spam'
	});

const resetPasswordSuccess = (state) =>
	updateObject(state, {
		statusMessage: 'A fost trimis un e-mail cu instrucțiuni in vederea resetării parolei.'
	});

const updatePasswordSuccess = (state) =>
	updateObject(state, {
		statusMessage:
      'Felicitari parola ta a fost cu success schimbata. Foloseste noua parola pentru a accessa platforma.'
	});

const updateUserStatus = (state, action) =>
	updateObject(state, { statusMessage: action.statusMessage });

const updateUserError = (state, action) => updateObject(state, { error: action.error });

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.LOGIN_USER_SUCCESS:
			return loginUserSuccess(state, action);
		case actionTypes.LOGIN_USER_START:
			return loginUserStart(state, action);
		case actionTypes.LOGIN_USER_FAIL:
			return loginUserFail(state, action);
		case actionTypes.REGISTER_USER_SUCCESS:
			return registerUserSuccess(state, action);
		case actionTypes.REGISTER_USER_FAIL:
			return registerUserFail(state, action);
		case actionTypes.UPDATE_USER_ERROR:
			return registerUserFail(state, action);
		case actionTypes.UPDATE_USER_STATUS:
			return updateUserStatus(state, action);
		case actionTypes.REGISTER:
			return updateUserError(state, action);
		case actionTypes.RESET_PASSWORD_SUCCESS:
			return resetPasswordSuccess(state, action);
		case actionTypes.UPDATE_PASSWORD_SUCCESS:
			return updatePasswordSuccess(state, action);
		case actionTypes.SET_OPEN_STREAK_MODAL:
			return setOpenStreakModal(state, action);
		case actionTypes.LOGOUT:
			return logoutUser(state);
		default:
			return state;
	}
};

export default reducer;
